/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const membershipCreateRestRequestSchema = z.object({
  commitment: z.number().nullish(),
  endDate: z.iso.date().nullish(),
  resourceId: z.int(),
  startDate: z.iso.date().nullish(),
  teamId: z.int(),
});
